import { Base } from "ui/Scripts/source/framework/base";
import { FileType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IDocumentListItem {
    id: string;
    code: string;
    comment: string;
    image: string;
    modifyUser: IModifyUser;
    fileType: FileType;
    locked: boolean;
    publishedId: string;
    publishedDate: number;
    publishedFileType: FileType;
    publishedImage: string;
    publishedApproved: boolean;
    documentVersionId: string;
}

export class DocumentListItem implements IDocumentListItem {
    id: string;
    code: string;
    comment: string;
    image: string;
    modifyUser: IModifyUser;
    fileType: FileType;
    locked: boolean;
    publishedId: string;
    publishedDate: number;
    publishedFileType: FileType;
    publishedImage: string;
    publishedApproved: boolean;
    documentVersionId: string;

    constructor();
    constructor(obj: IDocumentListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.image = obj && obj.image || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.fileType = obj && obj.fileType || FileType.Unknown;
        this.locked = obj && obj.locked || false;
        this.publishedId = obj && obj.publishedId || "";
        this.publishedDate = obj && obj.publishedDate || 0;
        this.publishedFileType = obj && obj.publishedFileType || FileType.Unknown;
        this.publishedImage = obj && obj.publishedImage || "";
        this.publishedApproved = obj && obj.publishedApproved || false;
        this.documentVersionId = obj && obj.documentVersionId || "";
    }

    static sortDocumentListItems(items: IDocumentListItem[], column = "modifyDate", asc = false): IDocumentListItem[] {
        if (!items && items.length < 2) return items;
        const collator = new Intl.Collator(Base.getCultureSimple(appConfig.culture));
        let result: IDocumentListItem[];
        if (column.equalIgnoreCase("modifyDate")) {
            result = items.sort((a: IDocumentListItem, b: IDocumentListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.modifyUser.date, b.modifyUser.date)); });
        } else if (column.equalIgnoreCase("comment")) {
            result = items.sort((a: IDocumentListItem, b: IDocumentListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.comment, b.comment)); });
        } else {
            result = items.sort((a: IDocumentListItem, b: IDocumentListItem) => { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.fileNameCompare(a.code, b.code, collator)); });
        }
        return result;
    }
}
